import { useEffect, useState } from "react";

import {
  denyConsent,
  grantConsent,
  initAnalytics,
  loadClarity,
  readStoredConsent,
  storeConsent,
  type ConsentCategories,
} from "@/lib/analytics";

/**
 * Bandeau de consentement (RGPD) : refus par defaut, choix explicite.
 * Tant que l'utilisateur n'a pas accepte, aucun script Google/Clarity n'est
 * charge (Consent Mode v2 reste en `denied`).
 */
export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    initAnalytics(); // pose dataLayer + consent default denied, sans reseau
    const stored = readStoredConsent();
    if (!stored) {
      setVisible(true);
      return;
    }
    if (stored.analytics) {
      grantConsent(stored);
      loadClarity();
    } else {
      denyConsent();
    }
  }, []);

  const decide = (categories: ConsentCategories) => {
    storeConsent(categories);
    if (categories.analytics) {
      grantConsent(categories);
      loadClarity();
    } else {
      denyConsent();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Consentement aux cookies de mesure d'audience"
      className="fixed inset-x-0 bottom-0 z-[70] border-t border-[var(--gold-line)] bg-card/95 backdrop-blur px-5 py-4"
    >
      <div className="max-w-5xl mx-auto flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-[13px] font-light leading-relaxed text-muted-foreground">
          J'utilise des cookies de mesure d'audience pour comprendre comment le site est consulté.
          Rien n'est déposé sans votre accord.{" "}
          <a
            href="/politique-confidentialite"
            className="text-[var(--gold)] underline underline-offset-4"
          >
            En savoir plus
          </a>
        </p>
        <div className="flex shrink-0 gap-3">
          <button
            type="button"
            onClick={() => decide({ analytics: false, marketing: false })}
            className="border border-[var(--gold-line)] px-5 py-2.5 text-[11px] uppercase tracking-[0.18em] text-muted-foreground hover:text-foreground transition-colors"
          >
            Refuser
          </button>
          <button
            type="button"
            onClick={() => decide({ analytics: true, marketing: false })}
            className="bg-[var(--gold)] text-[var(--ink)] px-5 py-2.5 text-[11px] font-semibold uppercase tracking-[0.18em]"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
